'use client';

import React from 'react';
import PropTypes from 'prop-types';

SearchAutocompleteList.propTypes = {
    onSelect: PropTypes.func.isRequired,
    results: PropTypes.array.isRequired,
};

export default function SearchAutocompleteList({ onSelect, results }) {

    return (
        <ul className="searchAutoComplete">
            {results.length > 0 ? (
                <>
                    {results.map((result, key) => (
                        <li
                            key={key}
                            className="searchAutoComplete__option"
                            onClick={() => onSelect(result)}
                        >
                            <h3 className="searchAutoComplete__title">
                                {result.description}
                            </h3>
                        </li>
                    ))}
                </>
            ) : (
                <li className="searchAutoComplete__option searchAutoComplete__option--none">
                    <div className="searchAutoComplete__title">
                        No results found
                    </div>
                </li>
            )}
        </ul>
    );
}
